import { IconSvgProps } from '../../../../../components/Icon/Icon';
import BaseLibraryIconSvg from '../../../../../components/Icon/BaseLibraryIconSvg';

export default function Close(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg {...props}>
      <path
        d='M3.25622 20.7395C3.61088 21.0841 4.18552 21.0841 4.53462 20.7395L11.9957 13.2638L19.4714 20.7395C19.8059 21.0841 20.3906 21.0841 20.7397 20.7395C21.0843 20.3803 21.0843 19.8057 20.7397 19.4667L13.264 11.9955L20.7397 4.53438C21.0843 4.18528 21.0943 3.60055 20.7397 3.25598C20.3805 2.91697 19.8059 2.91697 19.4714 3.25598L11.9957 10.7272L4.53462 3.25598C4.18552 2.91697 3.60079 2.90688 3.25622 3.25598C2.91722 3.61065 2.91722 4.18528 3.25622 4.53438L10.7274 11.9955L3.25622 19.4667C2.91722 19.8057 2.90713 20.3904 3.25622 20.7395Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
